export enum RegimeAnalysisMethodConstants {
  RETURN_PERCENTILE = 'ReturnPercentile',
  RETURN_THRESHOLD = 'ReturnThreshold',
  REGIME_RAW_LEVEL_THRESHOLD = 'RegimeRawLevelThreshold',
  RETURN_STANDARD_DEVIATION = 'ReturnStandardDeviation',
  DATE = 'Date',
}
